module.exports = __webpack_public_path__ + "static/media/view.932ccb9f.svg";